import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Chip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import axios from "axios";

const DialogTags2 = ({ open, handleClose, startupData, innovationId }) => {
  const [categories, setCategories] = useState([]); // JSON completo
  const [selectedTags, setSelectedTags] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const [taxonomyRes, innovationRes] = await Promise.all([
          axios.get(`${apiUrl}/taxonomies?type=category`),
          axios.get(`${apiUrl}/innovations/${innovationId}?admin=true`)
        ]);

        const taxonomyData = taxonomyRes.data.data;
        const selected = innovationRes.data.data?.taxonomies?.categories || [];

        console.log("selected",selected)

        setCategories(taxonomyData);
        setSelectedTags(selected);
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };

    fetchData();
  }, [innovationId]);

  const handleTagSelect = (tag) => {
    if (!selectedTags.some((t) => t.id === tag.id)) {
      setSelectedTags([...selectedTags, tag]);
    }
  };

  const handleTagRemove = (tagId) => {
    setSelectedTags(selectedTags.filter((tag) => tag.id !== tagId));
  };

  const handleSave = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const payload = { categories: selectedTags.map((tag) => Number(tag.id)) };
      await axios.patch(`${apiUrl}/innovations/${innovationId}`, payload);
      handleClose();
    } catch (err) {
      console.error("Error saving tags:", err);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{
        fontWeight: "bold", backgroundColor: "#191919", color: "white", fontFamily: "Urbanist"
      }}>
        Sectors of Competence
      </DialogTitle>

      <DialogContent sx={{ backgroundColor: "#191919", color: "white" }}>
        <div className="flex flex-wrap gap-2 mb-4">
          {selectedTags.map((tag) => (
            <Chip
              key={tag.id}
              label={tag.name}
              onDelete={() => handleTagRemove(tag.id)}
              deleteIcon={
                <span style={{
                  color: "rgb(var(--global-color-primary))",
                  fontWeight: "bold",
                  cursor: "pointer"
                }}>&times;</span>
              }
              sx={{
                backgroundColor: "transparent",
                border: "1.5px solid rgb(var(--global-color-primary))",
                borderRadius: "5px",
                fontFamily: "Urbanist",
                color: "rgb(var(--global-color-primary))",
                fontWeight: "bold",
              }}
            />
          ))}
        </div>

        {categories.map((first) => (
          <Accordion key={first.id} disableGutters>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
              sx={{ backgroundColor: "#5a5b5b", color: "white" }}
            >
              <Typography sx={{ fontWeight: "bold", fontFamily: "Urbanist" }}>{first.name}</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ backgroundColor: "#2a2a2a" }}>
              {first.children?.map((second) => (
                <Accordion key={second.id} disableGutters sx={{ mb: 2 }}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
                    sx={{ backgroundColor: "#3a3a3a", color: "white" }}
                  >
                    <Typography sx={{ fontFamily: "Urbanist", fontWeight: "bold" }}>
                      {second.name}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      backgroundColor: "#191919",
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 2,
                    }}
                  >
                    {second.children && second.children.length > 0 ? (
                      second.children.map((third) => (
                        <Chip
                          key={third.id}
                          label={third.name}
                          onClick={() => handleTagSelect({ id: third.id, name: third.name })}
                          disabled={selectedTags.some((t) => t.id === third.id)}
                          sx={{
                            backgroundColor: selectedTags.some((t) => t.id === third.id)
                              ? "rgba(255,255,255,0.3)"
                              : "white",
                            fontFamily: "Urbanist",
                            color: selectedTags.some((t) => t.id === third.id)
                              ? "gray"
                              : "black",
                            fontWeight: "bold",
                            cursor: selectedTags.some((t) => t.id === third.id)
                              ? "not-allowed"
                              : "pointer",
                            "&:hover": {
                              backgroundColor: selectedTags.some((t) => t.id === third.id)
                                ? "rgba(255,255,255,0.3)"
                                : "rgb(var(--global-color-primary))",
                              color: "black",
                            },
                          }}
                        />
                      ))
                    ) : (
                      <Chip
                        key={second.id}
                        label={second.name}
                        onClick={() => handleTagSelect({ id: second.id, name: second.name })}
                        disabled={selectedTags.some((t) => t.id === second.id)}
                        sx={{
                          backgroundColor: selectedTags.some((t) => t.id === second.id)
                            ? "rgba(255,255,255,0.3)"
                            : "white",
                          fontFamily: "Urbanist",
                          color: selectedTags.some((t) => t.id === second.id)
                            ? "gray"
                            : "black",
                          fontWeight: "bold",
                          cursor: selectedTags.some((t) => t.id === second.id)
                            ? "not-allowed"
                            : "pointer",
                          "&:hover": {
                            backgroundColor: selectedTags.some((t) => t.id === second.id)
                              ? "rgba(255,255,255,0.3)"
                              : "rgb(var(--global-color-primary))",
                            color: "black",
                          },
                        }}
                      />
                    )}
                  </AccordionDetails>
                </Accordion>
              ))}
            </AccordionDetails>

          </Accordion>
        ))}
      </DialogContent>

      <DialogActions sx={{ backgroundColor: "#191919" }}>
        <Button
          onClick={handleClose}
          sx={{
            backgroundColor: "gray", color: "white",
            "&:hover": { backgroundColor: "rgba(128, 128, 128, 0.8)" }
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          sx={{
            backgroundColor: "rgb(var(--global-color-primary))", color: "black", fontWeight: "bold",
            "&:hover": { backgroundColor: "rgba(var(--global-color-primary), 0.8)" }
          }}
        >
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogTags2;
